import classNames from 'classnames'

import {colorCodes, fillColorNone} from 'definitions/constant'
import {SvgIcon} from '../SvgIcon'

export const ContentMixedIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-transparent',
  strokeWidth = 0.6,
  fillColor = fillColorNone,
  classes,
  onClick,
  datacy,
}) => (
  <svg
    data-cy={`content-mixed-icon${datacy}`}
    onClick={e => {
      e.stopPropagation()
      onClick && onClick(e)
    }}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    className={classNames('stroke-current', strokeColor, classes)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9497 4.05095C11.2125 1.31374 6.78743 1.31374 4.05022 4.05095C1.31301 6.78817 1.31301 11.2132 4.05022 13.9504C6.78743 16.6877 11.2125 16.6877 13.9497 13.9504C16.6869 11.2132 16.6869 6.78817 13.9497 4.05095ZM13 9.04365C12.3077 9.68168 11.3538 10.0007 10.6307 10.0007C10.1846 10.0007 9.81535 9.92708 9.06151 9.65714L8.5692 9.47309C7.98458 9.27677 7.61535 9.19089 7.29228 9.19089C6.75382 9.19089 6.26151 9.43628 5.83074 9.80438L4.99997 8.95776C5.69228 8.30745 6.63074 8.0007 7.3692 8.0007C7.79997 8.0007 8.18459 8.06205 8.92305 8.33199L9.41535 8.51604C9.99997 8.72463 10.3846 8.79825 10.7077 8.79825C11.2461 8.79825 11.723 8.55285 12.1692 8.18475L13 9.04365Z"
      fill="white"
    />
    <rect
      x="0.25"
      y="0.25"
      width="17.5"
      height="17.5"
      rx="8.75"
      stroke="white"
      strokeWidth={strokeWidth}
    />
  </svg>
)

export const ContentIgnoreIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-transparent',
  strokeWidth = 0.6,
  fillColor = fillColorNone,
  classes,
  onClick,
  datacy,
}) => (
  <svg
    data-cy={`content-ignore-icon${datacy}`}
    onClick={e => {
      e.stopPropagation()
      onClick && onClick(e)
    }}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    className={classNames('stroke-current', strokeColor, classes)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9497 4.05095C11.2125 1.31374 6.78743 1.31374 4.05022 4.05095C1.31301 6.78817 1.31301 11.2132 4.05022 13.9504C6.78743 16.6877 11.2125 16.6877 13.9497 13.9504C16.6869 11.2132 16.6869 6.78817 13.9497 4.05095ZM13 9.04365C12.3077 9.68168 11.3538 10.0007 10.6307 10.0007C10.1846 10.0007 9.81535 9.92708 9.06151 9.65714L8.5692 9.47309C7.98458 9.27677 7.61535 9.19089 7.29228 9.19089C6.75382 9.19089 6.26151 9.43628 5.83074 9.80438L4.99997 8.95776C5.69228 8.30745 6.63074 8.0007 7.3692 8.0007C7.79997 8.0007 8.18459 8.06205 8.92305 8.33199L9.41535 8.51604C9.99997 8.72463 10.3846 8.79825 10.7077 8.79825C11.2461 8.79825 11.723 8.55285 12.1692 8.18475L13 9.04365Z"
      fill="#3E4345"
    />
    <rect
      x="0.25"
      y="0.25"
      width="17.5"
      height="17.5"
      rx="8.75"
      stroke="white"
      strokeWidth={strokeWidth}
    />
  </svg>
)

export const ContentBlockedIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-transparent',
  strokeWidth = 0.6,
  fillColor = fillColorNone,
  classes,
  onClick,
  datacy,
  ariaLabel,
}) => (
  <svg
    data-cy={datacy}
    onClick={e => {
      e.stopPropagation()
      onClick && onClick(e)
    }}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    className={classNames('stroke-current', strokeColor, classes)}
    aria-label={ariaLabel}
  >
    <path
      d="M9 2C5.129 2 2 5.129 2 9C2 12.871 5.129 16 9 16C12.871 16 16 12.871 16 9C16 5.129 12.871 2 9 2ZM12.5 11.513L11.513 12.5L9 9.987L6.487 12.5L5.5 11.513L8.013 9L5.5 6.487L6.487 5.5L9 8.013L11.513 5.5L12.5 6.487L9.987 9L12.5 11.513Z"
      fill="#E2423E"
    />
    <rect
      x="0.25"
      y="0.25"
      width="17.5"
      height="17.5"
      rx="8.75"
      stroke="white"
      strokeWidth={strokeWidth}
    />
  </svg>
)

export const ContentWarningIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-transparent',
  strokeWidth = 0.6,
  fillColor = fillColorNone,
  classes,
  onClick,
  datacy,
  ariaLabel,
}) => (
  <svg
    data-cy={datacy}
    onClick={e => {
      e.stopPropagation()
      onClick && onClick(e)
    }}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    className={classNames('stroke-current', strokeColor, classes)}
    aria-label={ariaLabel}
  >
    <path
      d="M13.9497 4.04936C11.2125 1.31215 6.78746 1.31215 4.05025 4.04936C1.31304 6.78657 1.31304 11.2116 4.05025 13.9489C6.78746 16.6861 11.2125 16.6861 13.9497 13.9489C16.687 11.2116 16.687 6.78657 13.9497 4.04936ZM9.69791 9.69702L8.29289 9.70621L8.30209 9.69702H4.74817L4.74817 8.30119L8.30209 8.30119L8.29289 8.292H9.70711L9.69791 8.30119L13.2518 8.30119L13.2518 9.69702H9.69791Z"
      fill="#F7C839"
    />
    <rect
      x="0.25"
      y="0.25"
      width="17.5"
      height="17.5"
      rx="8.75"
      stroke="white"
      strokeWidth={strokeWidth}
    />
  </svg>
)

export const ContentAllowedIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-transparent',
  strokeWidth = 0.6,
  fillColor = fillColorNone,
  classes,
  datacy,
  ariaLabel,
  onClick,
}) => (
  <svg
    data-cy={datacy}
    aria-label={ariaLabel}
    role="button"
    onClick={e => {
      e.stopPropagation()
      onClick && onClick(e)
    }}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    className={classNames('stroke-current', strokeColor, classes)}
  >
    <path
      d="M9 2C5.136 2 2 5.136 2 9C2 12.864 5.136 16 9 16C12.864 16 16 12.864 16 9C16 5.136 12.864 2 9 2ZM7.6 12.5L4.1 9L5.087 8.013L7.6 10.519L12.913 5.206L13.9 6.2L7.6 12.5Z"
      fill="#00D37E"
    />
    <rect
      x="0.25"
      y="0.25"
      width="17.5"
      height="17.5"
      rx="8.75"
      stroke="white"
      strokeWidth={strokeWidth}
    />
  </svg>
)

export const ContentExceptionIcon: SvgIcon = ({
  width = 16,
  height = 16,
  fillColor = fillColorNone,
  classes,
  datacy,
  ariaLabel,
  onClick,
}) => (
  <svg
    data-cy={datacy}
    aria-label={ariaLabel}
    role="img"
    focusable="false"
    {...(onClick
      ? {
          onClick: e => {
            e.stopPropagation()
            onClick(e)
          },
        }
      : {})}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    className={classes}
  >
    {ariaLabel ? <title>{ariaLabel}</title> : null}
    <circle cx="9" cy="9" r="8.8" fill="#082027" />
    <text
      x="9"
      y="9.35"
      textAnchor="middle"
      dominantBaseline="middle"
      fill={colorCodes.cyanBright}
      fontSize="13"
      fontWeight="500"
      fontFamily="Arial, Helvetica, sans-serif"
    >
      e
    </text>
  </svg>
)

export const FileUploadIcon: SvgIcon = ({
  width = 65,
  height = 64,
  fillColor = fillColorNone,
  classes,
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    viewBox="0 0 65 64"
    className={`${classes}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.1667 51.3327H18.5C15.5545 51.3327 13.1667 48.9449 13.1667 45.9993V20.666H46.5C49.4455 20.666 51.8333 23.0538 51.8333 25.9993V32.666"
      stroke="#5E6366"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.5 19.9993L34.0161 15.4455C33.0815 13.7321 31.2857 12.666 29.334 12.666H18.5C15.5545 12.666 13.1667 15.0538 13.1667 17.9993V29.3327"
      stroke="#5E6366"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.8333 39.334V51.334"
      stroke="#5E6366"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.8333 45.334L39.8333 45.334"
      stroke="#5E6366"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PlusButtonIcon: SvgIcon = ({
  width = 15,
  height = 16,
  fillColor = colorCodes.black,
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 4.75V11.25"
      stroke={fillColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.25 8L3.75 8"
      stroke={fillColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PlusButtonNoPaddingIcon: SvgIcon = ({
  width = 18,
  height = 19,
  fillColor = colorCodes.white,
  classes,
}) => (
  <svg
    width={width}
    height={height}
    fill={'none'}
    className={`${classes}`}
    viewBox="0 0 18 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7001 8.8H9.8001V4.8C9.8001 4.58783 9.71581 4.38434 9.56578 4.23431C9.41575 4.08429 9.21227 4 9.0001 4C8.78792 4 8.58444 4.08429 8.43441 4.23431C8.28438 4.38434 8.2001 4.58783 8.2001 4.8V8.8H4.3001C4.11445 8.8 3.9364 8.87375 3.80512 9.00502C3.67385 9.1363 3.6001 9.31435 3.6001 9.5C3.6001 9.68565 3.67385 9.8637 3.80512 9.99498C3.9364 10.1263 4.11445 10.2 4.3001 10.2H8.2001V14.2C8.2001 14.4122 8.28438 14.6157 8.43441 14.7657C8.58444 14.9157 8.78792 15 9.0001 15C9.21227 15 9.41575 14.9157 9.56578 14.7657C9.71581 14.6157 9.8001 14.4122 9.8001 14.2V10.2H13.7001C13.8857 10.2 14.0638 10.1263 14.1951 9.99498C14.3263 9.8637 14.4001 9.68565 14.4001 9.5C14.4001 9.31435 14.3263 9.1363 14.1951 9.00502C14.0638 8.87375 13.8857 8.8 13.7001 8.8Z"
      fill={fillColor}
    />
  </svg>
)
